import { render, staticRenderFns } from "./catalogfromtovar.vue?vue&type=template&id=c8965dc6&"
import script from "./catalogfromtovar.vue?vue&type=script&lang=js&"
export * from "./catalogfromtovar.vue?vue&type=script&lang=js&"
import style0 from "./catalogfromtovar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports